export default __webpack_public_path__ + "static/1-b78d7551c26f6c07c26d832f5ebc194f.jpeg";